// 个人信息---账号信息
export const formList = new Map([
  [
    'email',
    [
      {
        title: '邮箱地址：',
        warnInfo: '佰医将发送一封重置邮箱的邮件到你的新邮箱,请按照邮件提示完成账号确认。',
        prop: 'email',
        placeholder: '请输入新的邮箱地址',
        sureBtn: '发送验证邮箱',
      },
    ],
  ],
  [
    'phone',
    [
      {
        title: '手机号：',
        prop: 'phone',
        placeholder: '请输入手机号',
        sureBtn: '确定',
      },
      {
        title: '验证码：',
        prop: 'testWord',
        placeholder: '请输入验证码',
        sureBtn: '确定',
      },
    ],
  ],
  [
    'name',
    [
      {
        title: '姓' + '\xa0\xa0\xa0\xa0\xa0\xa0' + '名：',
        prop: 'name',
        placeholder: '请输入姓名',
        sureBtn: '确定',
      },
    ],
  ],
  [
    'oldPassword',
    [
      {
        title: '旧密码：',
        prop: 'oldPassword',
        placeholder: '请输入旧登陆密码',
        sureBtn: '确定',
      },
      {
        title: '新密码：',
        prop: 'newPasseord',
        placeholder: '请输入新登陆密码',
        sureBtn: '确定',
      },
      {
        title: '确认密码：',
        prop: 'repertPassword',
        placeholder: '请再次输入新登陆密码',
        sureBtn: '确定',
      },
    ],
  ],
  [
    'role',
    [
      {
        title: '所属角色：',
        prop: 'role',
        placeholder: '',
        sureBtn: '确定',
      },
    ],
  ],
]);

// 企业信息---首页
export const infoList = new Map([
  [
    '公司基本信息',
    [
      {
        title: '公司名称',
        prop: '北京佰医汇医疗信息技术有限公司',
        width: '50%',
      },
      {
        title: '注册地址',
        prop: '北京市海淀区商通大道1号院1号楼6层1018',
        width: '50%',
      },
    ],
  ],
  [
    '营业执照',
    [
      {
        title: '营业执照注册号',
        prop: '1234ABCD1234ABCD',
      },
      {
        title: '经营范围',
        prop:
          '技术开发、技术转让、技术咨询、技术服务、技术推广；市场调查；企业管理咨询；企业策划、设计；公共关系服务；设计、制作、代理、发布广告；会议服务；承办展览展示活动；经济贸易咨询；健康管理、健康咨询（须经审批的诊疗活动除外）；预防保健咨询（须经审批的诊疗活动外）。（企业依法自主选择经营项目，开展经营活动；依法须经批准的项目，经相关部门批准后依批准的内容开展经营活动；不得从事本市产业政策禁止和限制类项目的经营活动。)',
      },
      {
        title: '营业期限',
        prop: '2017-09-14 ~ 长期',
      },
      {
        title: '营业执照影印件',
        prop: '2017-09-14 ~ 长期',
      },
    ],
  ],
  [
    '企业法人／经办人',
    [
      {
        title: '证件持有人类型',
        prop: '业务经办人',
        width: '50%',
      },
      {
        title: '证件持有人类型',
        prop: '业务经办人',
        width: '50%',
      },
      {
        title: '证件类型',
        prop: '身份证',
        width: '50%',
      },
      {
        title: '证件号码',
        prop: '610302100000004527',
        width: '50%',
      },
      {
        title: '证件有效期',
        prop: '2009-12-15 至 2019-12-15',
      },
      {
        title: '证件影印件',
        prop: '',
      },
    ],
  ],
]);
// 企业信息---编辑
export const companyEdit = new Map([
  [
    'account/enterprise/edit',
    [
      {
        label: '',
        type: 'title',
        title: '企业基本信息',
      },
      {
        label: '公司名称',
        type: '',
        prop: 'companyName',
        edit: true,
      },
      {
        label: '',
        type: 'title',
        title: '营业执照',
      },
      {
        label: '营业执照照片',
        required: true,
        type: 'upload',
        prop: 'businessLicense',
        info: '必须为彩色图片且小于2M，文件格式为bmp、png、jpeg、jpg或gif',
        placeholder: '请添加营业执照照片',
      },
      {
        label: '营业执照类型',
        required: true,
        type: 'radio',
        prop: 'businessLicenseType',
        info:
          '在2015年10月1日后申请的营业执照，由18位数字和大写英文字母构成，“营业执照”“组织机构代码证”“税务登记证”三证合为一证。',
      },
      {
        label: '营业执照注册号',
        required: true,
        type: 'text',
        prop: 'businessLicenseNumber',
        info: '请填写营业执照注册号',
        placeholder: '请输入营业执照注册号',
      },
      {
        label: '注册地址',
        required: true,
        type: 'text',
        prop: 'address',
        info: '注册地址需与营业执照登记所一致',
        placeholder: '请输入注册地址',
      },
      {
        label: '经营范围',
        required: true,
        type: 'textarea',
        prop: 'businessScope',
        info: '经营范围需与营业执照登记所一致',
        placeholder: '请输入经营范围',
      },
      {
        label: '营业期限',
        required: true,
        type: 'date',
        prop: 'date',
        info: '请确认此项是否为最新信息',
        color: '#43AAB7',
        placeholder: '请选择营业期限',
      },
      {
        label: '',
        type: 'title',
        title: '企业法人/经办人',
      },
      {
        label: '证件持有人类型',
        required: true,
        type: '',
        prop: 'certificateHolderType',
      },
      {
        label: '证件类型',
        required: true,
        type: 'select',
        prop: 'certificateType',
        placeholder: '请选择证件类型',
      },
      {
        label: '证件正面照片',
        required: true,
        type: 'upload',
        prop: 'cardFront',
        info: '必须为彩色图片且小于2M，文件格式为bmp、png、jpeg、jpg或gif',
        placeholder: '请上传证件正面照片',
      },
      {
        label: '证件反面照片',
        required: true,
        type: 'upload',
        prop: 'cardBack',
        info: '必须为彩色图片且小于2M，文件格式为bmp、png、jpeg、jpg或gif',
        placeholder: '请上传证件反面照片',
      },
      {
        label: '证件持有人姓名',
        required: true,
        type: 'text',
        prop: 'certificateName',
        placeholder: '请输入证件持有人姓名',
      },
      {
        label: '证件号码',
        required: true,
        type: 'text',
        prop: 'certificateNumber',
        placeholder: '请输入证件号码',
      },
      {
        label: '证件有效期',
        required: true,
        type: 'date',
        prop: 'certificateValidity',
        placeholder: '请输入证件有效期',
      },
    ],
  ],
  [
    'account/enterprise/edit/name',
    [
      {
        label: '',
        type: 'title',
        title: '确认公司名称',
      },
      {
        label: '公司新名称',
        required: true,
        type: 'text',
        prop: 'companyName',
        placeholder: '请输入公司新名称',
      },
      {
        label: '工商局变更函照片',
        required: true,
        type: 'upload',
        prop: 'industrialPhoto',
        info:
          '请上传工商行政管理机关出具的变更登记证明文件。必须为彩色图片且小于2M，文件格式为bmp、png、jpeg、jpg或gif',
        placeholder: '请添加工商局变更函照片',
      },
      {
        label: '',
        type: 'title',
        title: '确认新营业执照',
      },
      {
        label: '营业执照照片',
        required: true,
        type: 'upload',
        prop: 'businessLicense',
        info: '必须为彩色图片且小于2M，文件格式为bmp、png、jpeg、jpg或gif',
        placeholder: '请添加营业执照照片',
      },
      {
        label: '营业执照注册号',
        required: true,
        type: 'text',
        prop: 'businessLicenseNumber',
        info: '请填写营业执照注册号',
        placeholder: '请输入营业执照注册号',
      },
      {
        label: '注册地址',
        required: true,
        type: 'text',
        prop: 'address',
        info: '注册地址需与营业执照登记所一致',
        placeholder: '请输入注册地址',
      },
      {
        label: '经营范围',
        required: true,
        type: 'textarea',
        prop: 'businessScope',
        info: '经营范围需与营业执照登记所一致',
        placeholder: '请输入经营范围',
      },
      {
        label: '营业期限',
        required: true,
        type: 'date',
        prop: 'date',
        color: '#43AAB7',
        placeholder: '请选择营业期限',
      },
      {
        label: '',
        type: 'title',
        title: '确认证件持有人信息',
      },
      {
        label: '证件持有人类型',
        required: true,
        type: '',
        prop: 'certificateHolderType',
      },
      {
        label: '证件类型',
        required: true,
        type: 'select',
        prop: 'certificateType',
        placeholder: '请选择证件类型',
      },
      {
        label: '证件正面照片',
        required: true,
        type: 'upload',
        prop: 'cardFront',
        info: '必须为彩色图片且小于2M，文件格式为bmp、png、jpeg、jpg或gif',
        placeholder: '请上传证件正面照片',
      },
      {
        label: '证件反面照片',
        required: true,
        type: 'upload',
        prop: 'cardBack',
        info: '必须为彩色图片且小于2M，文件格式为bmp、png、jpeg、jpg或gif',
        placeholder: '请上传证件反面照片',
      },
      {
        label: '证件持有人姓名',
        required: true,
        type: 'text',
        prop: 'certificateName',
        placeholder: '请输入证件持有人姓名',
      },
      {
        label: '证件号码',
        required: true,
        type: 'text',
        prop: 'certificateNumber',
        placeholder: '请输入证件号码',
      },
      {
        label: '证件有效期',
        required: true,
        type: 'date',
        prop: 'certificateValidity',
        placeholder: '请输入证件有效期',
      },
    ],
  ],
]);

// 账户管理---编辑
export const titleName = new Map([
  ['account/role/edit/member', ['账号信息', '权限信息']],
  ['account/role/edit', ['编辑角色', '权限说明']],
]);
